import styled from 'styled-components';

import media from '../../styles/media.style';
import { PAGE_WIDTH } from '../../styles/variables.style';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 140px;
`;

export const Flexbox = styled.div`
  display: flex;
  flex-direction: column;
  letter-spacing: 0.5px;
  line-height: 1.26;
  margin: auto;
  max-width: 100%;
  padding: 25px 20px 45px;
  width: ${PAGE_WIDTH}px;

  ${media.tabletL`
    flex-direction: row;
    padding: 85px 190px 75px;
  `};
`;

export const TitleSection = styled.div`
  ${media.tabletL`
    width: 50%;
  `};
`;

export const Title = styled.div`
  font-size: 38px;
  font-weight: 500;
  text-transform: uppercase;
`;

export const Duration = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.39;
  margin-top: 15px;
`;

export const Description = styled.div`
  margin-top: 20px;

  ${media.tabletL`
    margin-top: 0;
    width: 50%;
  `};

  h1,
  h2,
  h3,
  p {
    font-size: 18px;
    letter-spacing: 0.1px;
    line-height: 1.11;
  }
`;

export const Button = styled.div`
  background-color: black;
  color: white;
  cursor: pointer;
  padding: 25px 100px;
  text-transform: uppercase;
`;



// WEBPACK FOOTER //
// ./src/pages/TreatmentPage/TreatmentOverview.style.js